import root from './_root.js';
'use strict';
/** Built-in value references. */


var Symbol = root.Symbol;
export default Symbol;